import resolveConfig from 'tailwindcss/resolveConfig'
// import tailwindConfig from `${process.env.PUBLIC_URL}/tailwind.config.js`;
import tailwindConfig from '../theme.js'

export default function getTailwindConfig() {
  return resolveConfig(tailwindConfig)
}
